module.exports = __webpack_public_path__ + "static/media/(LH)-Artesanato-16.3786e65e.jpg";